import { getCookieValue } from 'dibs-consented-storage';
import { type Cookie } from './types.ts';

export function getAbUuid(cookie: Cookie): string | null {
    return getCookieValue(cookie, 'ab_uuid');
}
